export interface ShareUrls {
  facebook: string;
  twitter: string;
  linkedin: string;
}

/**
 * Generates social media share URLs for an article
 *
 * @param url - Full URL of the article to share
 * @param title - Title of the article
 * @returns Object containing share URLs for Facebook, Twitter/X, and LinkedIn
 */
export function generateShareUrls(url: string, title: string): ShareUrls {
  // Encode URL and title for use in query parameters
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  return {
    // Facebook share dialog
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,

    // Twitter/X intent tweet with URL and text
    twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,

    // LinkedIn share
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
  };
}
